import { useQuery } from "@tanstack/react-query";

import { useEffect } from "react";
import useEmailStore from "@store/useEmailStore";
import useSystemStore from "@store/useSystemStore";
import usePlatformStore from "@store/usePlatformStore";
import emailService from "@services/email.service";
import { EMAIL_QUERY_KEY, QUERY_CACHE_DEFAULT_EXPIRATION_MS } from "@config/query";
import { ItemType } from "@enums/common.enum";

export function useGetEmail(enabled: boolean = true) {
  const { itemId, itemType } = usePlatformStore();
  const { setEmailId, setThreadId } = useEmailStore();
  const { isAppActive } = useSystemStore();

  const isValidItem = !!itemId && itemType === ItemType.EMAIL;

  const { data, error, isLoading, fetchStatus, isPlaceholderData, refetch } = useQuery({
    enabled: enabled && isAppActive && isValidItem,
    queryKey: [EMAIL_QUERY_KEY, itemId],
    queryFn: async () => {
      return await emailService.getEmail(itemId);
    },
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
    retry: false,
  });

  useEffect(() => {
    setEmailId(data?.id ?? null);
    setThreadId(data?.thread ?? null);
  }, [data?.id, data?.thread, setEmailId, setThreadId]);

  return { data, error, isLoading, fetchStatus, isPlaceholderData, refetch };
}
